import React from 'react';
import reactDom from '../../../common/react/dom/index';

import ArchivioContainer from '../../../components/frontend/archivio/Archivio';

export default function init() {
	reactDom(<ArchivioContainer />, 'js-react-archivio');
}
